$(function() {
    // Hide Header on on scroll down
    var didScroll,
        lastScrollTop = 0,
        delta = 5,
        secondaryMenu = $('#secondaryMenu');
        navbarHeight = secondaryMenu.outerHeight();

    if ($(window).width() > 991) {
        $(window).scroll(function(event){
            didScroll = true;
        });
    } else {
        $(window).scroll(function() {
            var bookmark = $('.bookmark-btn');
            if($(window).scrollTop() > 0) {
                bookmark.addClass('scroll-btn');
            } else {
                bookmark.removeClass('scroll-btn');
            }
        });

        $(".bookmark-btn").on("click", function(e) {
            e.preventDefault();
            $(this).toggleClass('open');
            $('.secondary-menu').slideToggle();
        });
    }

    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(window).scrollTop();
        if(Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st > lastScrollTop && st > navbarHeight){
            secondaryMenu.addClass('scroll');
        } else {
            if(st + $(window).height() < $(document).height()) {
                secondaryMenu.removeClass('scroll');
            }
        }

        lastScrollTop = st;
    }

});